import { createStorageValue } from '@interhyp/platform-storage';
import { createValue } from '@interhyp/platform-value';
import { z } from 'zod';
import { mortgageIntentNamespace } from '../namespaces';
/* The preferred processor ("Wunschberater")
 */
export const preferredProcessorStorageValue = createStorageValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('preferredProcessor'),
    schema: z.string(),
    type: 'local',
});
export const preferredProcessorMemoryValue = createValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('preferredProcessorMemory'),
    schema: z.string(),
});
/* The preferred branch (location of the Interhyp branch - "Gewünschter Ort der Beratung") e.g. "PK NL M"
 */
export const brancheRequestStorageValue = createStorageValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('branchRequest'),
    schema: z.string(),
    type: 'local',
});
export const brancheRequestMemoryValue = createValue({
    namespace: mortgageIntentNamespace,
    id: Symbol('branchRequestMemory'),
    schema: z.string(),
});
